import { createContext, useContext } from "react";
import { ILangProvider } from "./LangProvider";
import { DEFAULT_LOCALE_LANG_ITEM } from "./langConstants";

export const LangProviderContext = createContext<ILangProvider>({
    availableCountries: {},
    availableLocales: [],
    getLangPath: () => '',
    lang: null,
    locale: null,
    localeLangItem: DEFAULT_LOCALE_LANG_ITEM,
    setLang: () => {},
    setLocale: () => {},
});
export const useLangContext = (): ILangProvider => {
    const context = useContext(LangProviderContext);
    if (!context) {
        throw new Error('LangContext cannot be used outside the LangContext provider')
    }
    return context;
}
